import type { FeatureStatus, MapFeature } from "./store"

export const getStatusColor = (status: FeatureStatus): string => {
  const colors = {
    Active: '#C5361B',
    Completed: '#236C19',
    Registered: '#E0B24D',
    Major: '#CA6E28',
    Closed: '#236C19',
  };
  return colors[status];
};

export const getPin = (status: FeatureStatus) => {
    let color = getStatusColor(status)
    if (status === 'Completed' || status == 'Closed') {
        return `<svg xmlns="http://www.w3.org/2000/svg" aria-label="completed outage marker" width="45" height="45" viewBox="0 0 100 100"><defs><clipPath id="b"><rect width="100" height="100"/></clipPath></defs><g id="a" clip-path="url(#b)"><rect width="100" height="100" fill="transparent"/><path d="M1322.289,127.413a34.636,34.636,0,0,0-34.636,34.636c0,29.815,34.636,51.33,34.636,51.33s34.636-21.515,34.636-51.33A34.636,34.636,0,0,0,1322.289,127.413Z" transform="translate(-1271.664 -119.559)" fill="${color}"/><g transform="translate(-1271.664 -119.559)"><circle cx="25" cy="25" r="25" transform="translate(1297.289 137.766)" fill="#4F7D70"/><circle cx="25" cy="25" r="25" transform="translate(1297.289 137.766)" fill="#4F7D70"/></g><path d="M1333.263,156.715l-14.219,14.219-8.48-8.48" transform="translate(-1271.664 -119.559)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="6"/></g></svg>`
    }
    if (status === 'Active') {
        return `<svg xmlns="http://www.w3.org/2000/svg" aria-label="current outage marker" width="45" height="45" viewBox="0 0 100 100"><defs><clipPath id="b"><rect width="100" height="100"/></clipPath></defs><g id="a" clip-path="url(#b)"><rect width="100" height="100" fill="transparent"/><g transform="translate(-1384.879 -119.559)"><path d="M1470,191.711l-15.013-26-15.013-26a4.967,4.967,0,0,0-8.6,0l-15.013,26-15.012,26a4.966,4.966,0,0,0,4.3,7.45H1465.7A4.967,4.967,0,0,0,1470,191.711Zm-34.373-37.723a3.028,3.028,0,0,1,3.22,2.733l-.665,21.688a2.4,2.4,0,0,1-2.56,2.178,2.447,2.447,0,0,1-2.606-2.178l-.656-21.688A3.074,3.074,0,0,1,1435.627,153.988Zm.055,36.211h-.055a3.617,3.617,0,1,1,.055,0Z" fill="${color}"/></g></g></svg>`
    }
    if (status === 'Registered') {
        return `<svg xmlns="http://www.w3.org/2000/svg" aria-label="registered works marker" width="45" height="45" id="Layer_1" viewBox="0 0 100 100" data-name="Layer 1"><title>upcoming-water-outage</title><path fill="${color}" d="M 50 5.29 A 34.64 34.64 0 0 0 15.38 39.93 C 15.38 69.74 50 91.26 50 91.26 S 84.66 69.74 84.66 39.93 A 34.64 34.64 0 0 0 50 5.29 Z m 0 54.08 A 18.72 18.72 0 1 1 68.74 40.65 A 18.72 18.72 0 0 1 50 59.37 Z" /></svg>`
    }
    if (status === 'Major') {
        return `<svg xmlns="http://www.w3.org/2000/svg" aria-label="major works marker" width="45" height="45" id="Layer_1" viewBox="0 0 100 100" data-name="Layer 1"><path fill="${color}" d="M 83.58 79.62 v 5 H 20.07 v -5 a 6.07 6.07 0 0 1 6.07 -6.07 h 4.72 l 2.81 -9.33 H 70 l 2.82 9.33 h 4.72 A 6.07 6.07 0 0 1 83.58 79.62 Z" /><path fill="${color}" d="M 60.8 33.84 H 42.85 l 4.34 -14.4 a 4.84 4.84 0 0 1 9.26 0 Z" /><polygon fill="${color}" points="67.07,54.62 36.57,54.62 39.95,43.44 63.7,43.44 67.07,54.62" /></svg>`
    }
    return '<svg xmlns="http://www.w3.org/2000/svg" aria-label="closed work marker" width="45" height="45" viewBox="0 0 100 100"><defs><clipPath id="b"><rect width="100" height="100"/></clipPath></defs><g id="a" clip-path="url(#b)"><rect width="100" height="100" fill="transparent"/><path d="M1322.289,127.413a34.636,34.636,0,0,0-34.636,34.636c0,29.815,34.636,51.33,34.636,51.33s34.636-21.515,34.636-51.33A34.636,34.636,0,0,0,1322.289,127.413Z" transform="translate(-1271.664 -119.559)" fill="${color}"/><g transform="translate(-1271.664 -119.559)"><circle cx="25" cy="25" r="25" transform="translate(1297.289 137.766)" fill="#4F7D70"/><circle cx="25" cy="25" r="25" transform="translate(1297.289 137.766)" fill="#4F7D70"/></g><path d="M1333.263,156.715l-14.219,14.219-8.48-8.48" transform="translate(-1271.664 -119.559)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="6"/></g></svg>'
}

export const svgToDataUri = (svgString: string) => {
    const base64 = btoa(svgString);
    return `data:image/svg+xml;base64,${base64}`;
}

export const getPinForImage = (status: FeatureStatus) => {
    let svgString = getPin(status)
    if (svgString) {
        return svgToDataUri(svgString);
    }
}

export function getTitle(status: FeatureStatus): string {
  switch (status) {
    case 'Completed':
    case 'Closed':
      return 'Recently Completed Works'
    case 'Active':
      return 'Current Water Outage'
    case 'Registered':
      return 'Upcoming Water Outage'
    default:
      return ''
  }
}

export function joinList(listArray: Array<string>) {
  if (!listArray || listArray.length === 0) return ''
  if (listArray.length === 1) return listArray[0]
  if (listArray.length === 2) return listArray[0] + ' and ' + listArray[1]

  const lastItem = listArray.slice(listArray.length - 1)
  const otherItems = listArray.slice(0, listArray.length - 1)
  return otherItems.join(', ') + ' and ' + lastItem
}

export const getLocalDateTimeString = (dateValue: Date | null) => {
if (!dateValue) return null;

return new Intl.DateTimeFormat('en-Au', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
}).format(dateValue).replace(',', '');
}


export function getMessage(planned: boolean) {
  return planned ? 'Planned water on: ' : 'Estimated water on: '
}

export function getDetails(content: MapFeature['properties']): string | null {
  switch (content.status) {
    case 'Completed':
    case 'Closed':
      return content?.actual_on ?? "";
    case 'Major':
    case 'Active':
      if(content.estimated_on){
        return content.estimated_on;
      }
      if(content.planned_on) {
        return content.planned_on
      }
      return ""
    case 'Registered':
      if (content.extension === 'True' && content.estimated_on) {
        return content.estimated_on
      }
      if (content.planned_on) {
        return content.planned_on
      } else if (content.estimated_on) {
        return content.estimated_on
      }
      return ''
    default:
      return ''
  }
}


export async function createMarker(feature: MapFeature, position: { lat: number, lng: number }) {
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
    const parser = new DOMParser()
    const content = parser.parseFromString(getPin(feature.properties.status), 'image/svg+xml').documentElement
    const marker = new AdvancedMarkerElement({
        position,
        content,
        title: feature.properties.work_order_number
    })
    return marker
}


export const createTemplate = (properties: MapFeature['properties'], outagesFormUrl: string) => {
    const lastUpdated = getLocalDateTimeString(new Date())
    const affectedSuburbs = joinList(properties.affected_suburbs)
    if (properties.status === 'Completed' || properties.status === 'Closed') {
        return `<div class="bg-white p-4 rounded-lg shadow-lg w-full max-w-[300px]" role="dialog" aria-label="Outage details for ${affectedSuburbs}" tabIndex="-1">
          <h5 class="mt-0">Recently completed works</h5>
          <h6>Work has recently been completed at ${affectedSuburbs}</h6>
          <p>
            Maintenance was recently carried out at ${affectedSuburbs}, service has
            been restored and water was turned back on at ${properties.actual_on}.
          </p>
          <p>
            As a result of the maintenance, you may notice discoloured water.
            Running a tap for approximately 2 minutes should return water to
            normal. If water does not return to normal, please contact us at 13 13
            75.
          </p>
        </div>`
    }
    if (properties.status === 'Active') {
        let outageStart = ''
        if (properties.actual_off) {
            outageStart = properties.actual_off
        } else if (properties.estimated_off) {
            outageStart = properties.estimated_off
        }
        let outageEnd = ''
        if (properties.planned_on) {
            outageEnd = properties.planned_on
        } else if (properties.estimated_on) {
            outageEnd = properties.estimated_on
        }

        if (properties.extension === 'True') {
            outageEnd = properties.estimated_on ?? ""
        }

        return `<div class="bg-white p-4 rounded-lg shadow-lg w-full max-w-[300px]" role="dialog" aria-label="Outage details for ${affectedSuburbs}">
          <h5 class="mt-0">Water outage</h5>
          <h6>Work in progress to restore outage at ${affectedSuburbs}</h6>
          <p>An outage is currently being worked on in ${affectedSuburbs}.</p>
          <p>
              <strong>Outage start:</strong> ${outageStart}<br />
              <strong>Estimated water on:</strong> ${outageEnd}
          </p>
          <p>Updates will be provided as they become available</p>
          <p>Last updated: ${lastUpdated}</p>
          <p>
            We apologise for any inconvenience caused and appreciate your
            patience
          </p>
          <a href="${outagesFormUrl}" class="link-arrow">SIGN UP FOR SUPPLY ALERTS</a>
        </div>`
    }
    if (properties.status === 'Registered') {
        let plannedOff = ''
        if (properties.planned_off) {
            plannedOff = properties.planned_off
        } else if (properties.estimated_off) {
            plannedOff = properties.estimated_off
        }
        let plannedOn = ''
        if (properties.planned_on) {
            plannedOn = properties.planned_on
        } else if (properties.estimated_on) {
            plannedOn = properties.estimated_on
        }

        if (properties.extension === 'True') {
            plannedOn = properties.estimated_on ?? ""
        }

        let isPlanned = properties.planned_flag === "True";
        const customerAffected = `<p><b>Affected customers:</b> ${properties.affected_customers_outage}</p>`

        return `<div class="bg-white p-4 rounded-lg shadow-lg w-full max-w-[300px]" role="dialog" aria-label="Outage details for ${affectedSuburbs}">
          <h5 class="mt-0">Upcoming water outage</h5>
            <h6>${isPlanned ? 'Scheduled maintenance is planned to begin in ' : 'Urgent repairs are required in '}${affectedSuburbs}</h6>
            <hr />
            <p>
                <b>${isPlanned ? 'Planned' : 'Estimated'} water off:</b> ${plannedOff}<br />
                <b>${isPlanned ? 'Planned' : 'Estimated'} water on:</b> ${plannedOn}
            </p>
          ${properties.affected_customers_outage ? customerAffected : ''}
          <p>Updates will be provided as they become available</p>
          <p>
            We apologise for the inconvenience and thank you for your patience while we complete this essential work
          </p>
          <a href="${outagesFormUrl}" class="link-arrow">SIGN UP FOR SUPPLY ALERTS</a>
        </div>`
    }

    if (properties.status === 'Major') {
        let outageStart = ''
        if (properties.actual_off) {
            outageStart = properties.actual_off
        } else if (properties.estimated_off) {
            outageStart = properties.estimated_off
        }
        let outageEnd = ''
        if (properties.planned_on) {
            outageEnd = properties.planned_on
        } else if (properties.estimated_on) {
            outageEnd = properties.estimated_on
        }

        if (properties.extension == 'True') {
            outageEnd = properties.estimated_on ?? ""
        }
        return `<div class="bg-white p-4 rounded-lg shadow-lg w-full max-w-[300px]" role="dialog" aria-label="Outage details for ${affectedSuburbs}">
          <h5 class="mt-0">${properties.name || 'Major Works'}</h5>
          <h6>Works are underway at ${affectedSuburbs}</h6>
          <p>
              <strong>Start:</strong> ${outageStart}<br />
              <strong>End:</strong> ${outageEnd}
          </p>
          <p>
            ${properties.notes}
          </p>
          <a href="${properties?.outagesFormUrl ?? outagesFormUrl}" class="link-arrow">${properties?.outagesFormUrl ? "MORE ABOUT DISCOLOURED WATER" : "SIGN UP FOR SUPPLY ALERTS"}</a>
        </div>`
    }
    return `<div class="bg-white p-4 rounded-lg shadow-lg w-full max-w-[300px]" role="dialog" aria-label="Outage details for ${affectedSuburbs}">
          <h5 class="mt-0">${affectedSuburbs}</h5>
          <h6>There are no known outages at this address</h6>
          <p>Last updated: ${lastUpdated}</p>
          <p>
            If you are experiencing a water outage at this address, please report the outage to one of our 24 hour support crew, so we can investigate.
          </p>
        </div>`
}


// Calculate the approximate centre of the polygon
export function getPolygonBoundsCenter(polygon: google.maps.Polygon) {
    const bounds = new google.maps.LatLngBounds();
    const paths = polygon.getPaths();
    paths.forEach(path => {
        path.forEach(point => bounds.extend(point));
    });
    const center = bounds.getCenter();
    return {
        lat: center.lat(),
        lng: center.lng()
    };
}


// Helper function to create cluster marker element
export const createClusterMarker = (count: number) => {
    const div = document.createElement('div');
    div.innerHTML = `
      <div style="
        background-color: #1a73e8;
        border-radius: 50%;
        color: white;
        height: 40px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 14px;
      ">
        ${count}
      </div>
    `;
    return div;
};

export const animateMarker = (
    marker: google.maps.marker.AdvancedMarkerElement,
    animation: 'BOUNCE'
  ) => {
    const element = marker.content as HTMLElement;
    if (!element) return;
    
    if (animation === 'BOUNCE') {
      element.style.transition = 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      element.style.transformOrigin = 'center bottom';
      
      const bounce = () => {
        element.style.transform = 'translateY(-20px) scale(1, 0.8)';
        
        setTimeout(() => {
          element.style.transform = 'translateY(0) scale(1, 1)';
          
          setTimeout(() => {
            element.style.transform = 'translateY(-10px) scale(1, 0.9)';
            
            setTimeout(() => {
              element.style.transform = 'translateY(0) scale(1, 1)';
              
              setTimeout(() => {
                element.style.transition = '';
              }, 50);
            }, 150);
          }, 200);
        }, 200);
      };
      
      bounce();
    }
  };

  // Helper function to check if a point is within viewport bounds
export const isPointInViewport = (
    point: google.maps.LatLng,
    bounds: google.maps.LatLngBounds
  ): boolean => {
    return bounds.contains(point);
  };

  export const fetchWithToken = async (url: string, token: string | null) => {
    if(!token) {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      let data = await response.json()
      return data.features
    }
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': token
      }
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    let data = await response.json()
    return data.features
  };

  export const createCountText = ({
    Closed,
    Completed,
    Registered,
    Active,
    Major
  }: {
    Closed: number
    Completed: number;
    Registered: number;
    Active: number;
    Major: number;
  }) => {
    let text = ''
    if (Major) {
      text = `${Major} major work${Major > 1 ? 's' : ''}`
    }
    if (Active) {
      text = `${text}${text && ", "}${Active} outage${Active > 1 ? 's' : ''}`
    }
    if (Completed) {
      text = `${text}${text && ", "}${Completed} recently completed work${Completed > 1 ? 's' : ''
        }`
    }
    if (Closed) {
        text = `${text}${text && ", "}${Closed} recently closed work${Completed > 1 ? 's' : ''
          }`
      }
    if (Registered) {
      text = `${text}${text && ", "}${Registered} upcoming water outage${Registered > 1 ? 's' : ''}`
    }
    return text
  }
  
  export const createGuid = () => {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    }
    return (
      s4() +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    )
  }

  export const renderCluster = (
    cluster: { count: number; position: google.maps.LatLng }
  ) => {
    const svg = `
      <svg aria-label="marker cluster icon" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="25" cy="25" r="20" fill="#1E3A8A" stroke="white" stroke-width="2"/>
        <text 
          x="25" 
          y="25" 
          font-size="14" 
          fill="white" 
          text-anchor="middle" 
          dominant-baseline="middle"
          font-family="Arial"
        >${cluster.count}</text>
      </svg>
    `;

    const parser = new DOMParser();
    return parser.parseFromString(svg, 'image/svg+xml').documentElement;
  };

  export const locationRestriction = {
    north: -10.285886421238, // Increased north boundary
    south: -45.03144056131, // Decreased south boundary
    east: 155.5959952573436, // Increased east boundary
    west: 90.4397452573436,  // Decreased west boundary
  } as const;

  export const outagesMapCenter = { lat: -25, lng: 121 } as const
  
  export const outagesMapSettings = {
    center: outagesMapCenter,
    restriction: {
      latLngBounds: locationRestriction,
      strictBounds: false,
    },
    minZoom: 5,
    zoom: 5,
    maxZoom: 17,
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: true,
    mapId: 'Water'
  } as const
